import { Component, ElementRef } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { DateIntervalValidation } from '@validators/date-interval-validation';
import { DatePeriodValidation } from '@validators/date-period-validation';
import { DateValidation } from '@validators/date.validation';
import moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

@Component({
  selector: 'filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent {

  public isFilterExpanded = false;
  public readonly defaultFilterValues = {
    openedAtGte: moment().subtract(1, 'month'),
    openedAtLte: moment(),
    closedAtGte: null,
    closedAtLte: null,
    scheduledAtGte: null,
    scheduledAtLte: null,
    locations: null,
    segments: null,
    companies: null,
    locationGroups: null,
    maintenanceTypes: null
  };
  public filtersForm = new FormGroup({
    openedAtGte: new FormControl(this.defaultFilterValues.openedAtGte, [DateValidation.validate]) ,
    openedAtLte: new FormControl(this.defaultFilterValues.openedAtLte, [DateValidation.validate]),
    closedAtGte: new FormControl(this.defaultFilterValues.closedAtGte, [DateValidation.validate]),
    closedAtLte: new FormControl(this.defaultFilterValues.closedAtLte, [DateValidation.validate]),
    scheduledAtGte: new FormControl(this.defaultFilterValues.scheduledAtGte, [DateValidation.validate]),
    scheduledAtLte: new FormControl(this.defaultFilterValues.scheduledAtLte, [DateValidation.validate]),
    locations: new FormControl(this.defaultFilterValues.locations),
    maintenanceTypes: new FormControl(this.defaultFilterValues.maintenanceTypes),
    segments: new FormControl(this.defaultFilterValues.segments),
    companies: new FormControl(this.defaultFilterValues.companies),
    locationGroups: new FormControl(this.defaultFilterValues.locationGroups)
  },
    {
      validators: [
        DateIntervalValidation.validate({
          from: 'openedAtGte',
          to: 'openedAtLte',
          maxDiffLte: 365,
          unit: 'days'
        }),
        DatePeriodValidation.validate(['openedAt', 'closedAt', 'scheduledAt'])
      ]
    });

  constructor(
    private elementRef: ElementRef,
    private readonly fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  public getHeight(): number {
    return this.elementRef.nativeElement.offsetHeight;
  }
}
